export default "__VITE_ASSET__d8fca6cb__"